import type { SVGProps } from "react";

interface ChevronProps extends SVGProps<SVGSVGElement> {
  scale?: number;
}

const Chevron = ({ scale = 1, ...props }: ChevronProps) => {
  return (
    <svg
      width={16 * scale}
      height={16 * scale}
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M9.24268 12.6L4.64648 8.00381L9.24268 3.40762"
        stroke={"var(--svg-color, #000)"}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Chevron;
